import styled from 'styled-components';

const TextAlignCenter = styled.div({
  textAlign: 'center',
});

export { TextAlignCenter };
